export function getShortId() {
    return Array.from(window.crypto.getRandomValues(new Uint32Array(2)))
        .map(r => r.toString(36).padStart(7, '0'))
        .join('-');
}
